module.exports = __webpack_public_path__ + "img/icon-014.299d3ffa.png";